import { gql } from '@apollo/client';
import { achievementFragment } from '../fragments/achievement';

export const getSingleAchievementQuery = gql`
    ${achievementFragment}

    query GetSingleAchievement($id: String!) {
        achievement(id: $id) {
            ...AchievementFields
        }
    }
`;
